export const START_GET_USER_DETAILS_TRANSPORT = 'user/START_GET_USER_DETAILS_TRANSPORT'
export const SAVE_GET_USER_DETAILS_TRANSPORT = 'user/SAVE_GET_USER_DETAILS_TRANSPORT'
export const ERROR_GET_USER_DETAILS_TRANSPORT = 'user/ERROR_GET_USER_DETAILS_TRANSPORT'
export const ADD_FAVORITE_LISTING = 'user/ADD_FAVORITE_LISTING'
export const REMOVE_FAVORITE_LISTING = 'user/REMOVE_FAVORITE_LISTING'
